<template>
  <div class="flex">
    <div
      class="
        flex
        justify-center
        items-center
        w-10
        h-10
        border-2 border-primary
        bg-white
        rounded-full
        text-center
      "
    >
      <p class="font-bold text-xs text-primary">
        {{ getFilterIdentifier() }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  name: 'filter-identifier',

  props: {
    filterIdentifier: {
      required: true,
    },
  },

  methods: {
    getFilterIdentifier() {
      let filterId = this.$t('frontend_groovemail_analytics_list_if');
      if (this.filterIdentifier === 'trigger') {
        filterId = this.$t('frontend_groovemail_analytics_list_if');
      } else if (this.filterIdentifier === 'condition') {
        filterId = this.$t('frontend_groovemail_analytics_list_and');
      } else if (this.filterIdentifier === 'action') {
        filterId = this.$t('frontend_groovemail_analytics_list_then');
      }
      return filterId;
    },
  },
};
</script>
